import { render, staticRenderFns } from "./mdi-database.vue?vue&type=template&id=6b493266&"
import script from "./mdi-database.vue?vue&type=script&lang=js&"
export * from "./mdi-database.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b493266')) {
      api.createRecord('6b493266', component.options)
    } else {
      api.reload('6b493266', component.options)
    }
    module.hot.accept("./mdi-database.vue?vue&type=template&id=6b493266&", function () {
      api.rerender('6b493266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/mdi-database.vue"
export default component.exports